import { SHOP_PREFIX } from '@perpay-web/constants/paths';
import {
    LAST_REACT_STOREFRONT_PAGE,
    REACT_STOREFRONT_HISTORY,
    MAX_STOREFRONT_HISTORY_LENGTH,
} from '@perpay-web/constants/storage';
import { isAppBrowserAgent } from '@perpay-web/utils/userAgentUtils';

const isMessageLink = (url) =>
    url.startsWith('mailto:') || url.startsWith('sms:');

const isBlobLink = (url) => url.startsWith('blob:');

// Returns whether the provided path is handled by the React app
export const pathIsInternalToApp = (path) => {
    if (!path) {
        return false;
    }

    if (typeof path !== 'string') {
        return false;
    }

    if (isMessageLink(path)) {
        return false;
    }

    if (path.startsWith('http')) {
        return false;
    }

    if (isBlobLink(path)) {
        return false;
    }

    return true;
};

export const pathIsInReactStorefront = (path) =>
    pathIsInternalToApp(path) && path.startsWith(SHOP_PREFIX);

export const getLastReactStorefrontPage = () =>
    window.localStorage.getItem(LAST_REACT_STOREFRONT_PAGE);

export const setLastReactStorefrontPage = (location) => {
    window.localStorage.setItem(
        LAST_REACT_STOREFRONT_PAGE,
        `${location.pathname}${location.search}`,
    );
};

export const clearLastReactStorefrontPage = () =>
    window.localStorage.removeItem(LAST_REACT_STOREFRONT_PAGE);

export const getAnchorTargetFromUserAgent = () =>
    isAppBrowserAgent() ? '_system' : '_blank';

export const getReactStorefrontHistory = () => {
    if (window.localStorage) {
        return JSON.parse(
            window.sessionStorage.getItem(REACT_STOREFRONT_HISTORY),
        );
    }

    return null;
};

/**
 * Returns the previous storefront path index that the user visited or -1 if none was found
 * @param {string[]} history
 * @param {string} currentPath
 * @returns {number}
 */
export const getPreviousShopPathIndex = (history, currentPath) => {
    const hasMultipleHistoryEntries =
        Array.isArray(history) && history.length > 1;

    if (!hasMultipleHistoryEntries) {
        return -1;
    }

    return history.findIndex(
        (path) => pathIsInReactStorefront(path) && path !== currentPath,
    );
};

export const setReactStorefrontHistory = (routeState) => {
    const history = getReactStorefrontHistory() || [];
    const { location, historyAction } = routeState;
    const { pathname, search, state } = location;
    const isReplace = historyAction === 'REPLACE';
    const replacedHistory = isReplace ? history.slice(1) : history;

    const value = `${pathname}${search}`;
    const { isHomeNavigation = false } = state || {};
    const isNavigateBack = historyAction === 'POP';

    let updatedHistory;
    if (isHomeNavigation) {
        updatedHistory = [];
    } else if (isNavigateBack) {
        const step = replacedHistory.findIndex((path) => path === value);
        const isStepFound = step !== -1;
        updatedHistory = isStepFound ? replacedHistory.slice(step) : [];
    } else {
        updatedHistory = [value, ...replacedHistory].slice(
            -MAX_STOREFRONT_HISTORY_LENGTH,
        );
    }

    window.sessionStorage.setItem(
        REACT_STOREFRONT_HISTORY,
        JSON.stringify(updatedHistory),
    );
};
